/* eslint-disable no-debugger */
import { useEffect, useState } from 'react';
import useActiveClubsData from '../../../state/activeClubs/UseActiveClubsData';

const useClubMultiSelect = (filterIds) => {
  const { activeClubsState, getActiveClubs } = useActiveClubsData();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (activeClubsState.isArrayLoading === false && activeClubsState.isArrayLoaded === false) {
      getActiveClubs();
    } else if (activeClubsState.isArrayLoading === false && activeClubsState.isArrayLoaded === true) {
      const clubOptions = [];
      // const filterIdArray = filterIds && filterIds.length > 0 ? filterIds.split(',').map(id => parseInt(id)) : [];
      const filterIdArray = filterIds && filterIds.length > 0 ? filterIds.split(',').map(id => id) : [];

      for (const club of activeClubsState.data) {
        if (club.orgUnitId.length > 0 && (filterIdArray.length === 0 || filterIdArray.includes(club.parentOrgUnitId))) {
          clubOptions.push({ id: club.orgUnitId, name: `${club.orgUnitName} - ${club.parentOrgUnitCode}` });
        }
      }

      setOptions(clubOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeClubsState, filterIds]);

  return {
    activeClubsState,
    options
  };
};

export default useClubMultiSelect;